/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import NoHashModal from './modules/no-hash-modal'
_('no-hash-modal').nodes().map((el) => new NoHashModal(el))

----------------------------------------------------------------------------
Attributes on trigger element:
----------------------------------------------------------------------------
data-behaviour="no-hash-modal"    - For setting up the click event
data-target="element"     - For targeting another element

----------------------------------------------------------------------------
Attributes on target element:
----------------------------------------------------------------------------
data-element="element"           - To match the triggers data-target
data-class="target-class"        - Class to be toggled

----------------------------------------------------------------------------
Other attributes
----------------------------------------------------------------------------
data-modal-focus     - first element focused on open

*/

import { _ } from '../utils'
import { makeGtmCall } from './../tracking'
import axios from 'axios'
import config from './../config/main'
class NoHashModal {
    constructor(el) {
        this.el = el
        this.body = document.body

        this.el.addEventListener('click', this.toggleModal)
    }

    hitEndpoint = (endpoint, endpointMethod) => {
        axios({
            method: endpointMethod,
            url: endpoint,
            header: config.axiosHeader
        })
            .then(() => {
                console.log('success')
            })
            .catch(() => {
                console.log('error')
            })
    }

    toggleModal = (e) => {
        const trigger = e.currentTarget
        const target = _(trigger.dataset.target, 'element').node()
        const triggerClass = trigger.dataset.class
        const targetClass = target.dataset.class
        const focusElement = _('', 'modal-focus').nodeFrom(target)
        const modalOpenOnLoad = target.classList.contains(targetClass)

        target.classList.toggle(targetClass)

        const modalOpen = target.classList.contains(targetClass)
        target.dataset.open = modalOpen

        trigger.dataset.gtmEvent = trigger.dataset.gtmEvent || 'modal-open'
        trigger.dataset.gtmName = trigger.dataset.gtmName || trigger.dataset.target

        if (modalOpen) {
            makeGtmCall(el)
            if (focusElement) {
                setTimeout(() => {
                    focusElement.focus()
                }, 300)
            }
        } else {
            if (focusElement) {
                focusElement.blur()
            }
        }

        if (modalOpenOnLoad && trigger.dataset.endpoint) {
            const endpoint = trigger.dataset.endpoint
            const endpointMethod = trigger.dataset.endpointMethod
            this.hitEndpoint(endpoint, endpointMethod)
        }

        if (triggerClass) {
            trigger.classList.toggle(triggerClass)
        }

        if (modalOpen && trigger.dataset.video === 'true') {
            _('video-play').nodeFrom(target).dispatchEvent(new Event('click'))
        }

        if (!modalOpen && trigger.dataset.video === 'true') {
            _('video-pause').nodeFrom(target).dispatchEvent(new Event('click'))
        }

        this.toggleScroll(target)
    }

    stopScroll = (target) => {
        target.dataset.open = true
        target.dataset.position = window.pageYOffset
        this.body.style.height = window.outerHeight
        this.body.style.overflow = 'hidden'
        this.body.classList.add('body--modal')
        window.scrollTo(0, 0)
    }

    startScroll = (target = false) => {
        this.body.style.height = null
        this.body.style.overflow = null
        this.body.classList.remove('body--modal')
        if (target) {
            target.dataset.open = false
            window.scrollTo(0, target.dataset.position)
        }
    }

    toggleScroll = (target) => {
        if (!target.dataset.open || target.dataset.open === 'true') {
            this.stopScroll(target)
        } else {
            this.startScroll(target)
        }
    }
}

export default NoHashModal
